/**
 * Shared player utilities for cantera stats module.
 */
import { getMediaBaseUrl } from '../../utils/mediaUrl';

const mediaUrl = getMediaBaseUrl();

export function getPlayerAvatarUrl(playerId) {
  return playerId
    ? `${mediaUrl}/photos/${playerId}.png?${new Date().getTime()}`
    : '/path/to/default-player-avatar.png';
}
